import React from 'react';

const Favicon = () => {
  return (
    <>
      <link rel="icon" href="/assets/icons/lucaverse-logo1/lucaverse-logo1_32x32.ico" />
      <link rel="apple-touch-icon" href="/assets/logos/lucaverse-logo1.png" />
    </>
  );
};

export default Favicon;